import { render, staticRenderFns } from "./UpsellVideoDialog.vue?vue&type=template&id=467ec0f3&"
import script from "./UpsellVideoDialog.vue?vue&type=script&lang=ts&"
export * from "./UpsellVideoDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports